import { breakpointsBootstrapV5, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsBootstrapV5)

export const isScreenSM = breakpoints.greater('sm')
export const isScreenMD = breakpoints.greater('md')
export const isScreenLG = breakpoints.greater('lg')
export const isScreenXL = breakpoints.greater('xl')
export const isScreenXXL = breakpoints.greater('xxl')

export default breakpoints
